"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = exports.fetch = void 0;
const constants_1 = require("../constants");
function fetch(params) {
    return {
        data: params,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/groups/central-feed/fetch`,
    };
}
exports.fetch = fetch;
function query(params) {
    return {
        data: params,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/groups/central-feed/query`,
    };
}
exports.query = query;
//# sourceMappingURL=http.js.map